import { Box } from '@mui/material';
import { FC } from 'react';
import { DataTable } from 'src/components/organisms/DataTable/DataTable';
import { HeatMapTypeEnum } from 'src/mapping/projected-option-count.mapping';
import { defaultColDef } from './data/columns';
import { useProjectedOptionCountColumns } from './data/useProjectedOptionCountColumns';

export interface HeatMapTableProps {
    type: HeatMapTypeEnum;
}

export const ProjectedOptionCountHeatMapTable: FC<HeatMapTableProps> = ({ type }) => {
    const { data: rows, columns, loading } = useProjectedOptionCountColumns({ type });

    return (
        <Box className="ag-theme-alpine-custom-compact ag-sum">
            <DataTable
                autoSizeToFit
                headerHeight={60}
                rows={rows}
                columns={columns}
                defaultColDef={defaultColDef}
                loading={loading}
                domLayout="autoHeight"
            />
        </Box>
    );
};
